import axios from 'axios'

export default {
    namespaced: true,
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        fetch({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return new Promise((resolve, reject) => {
                axios.get(
                    '/api/beauty-manager/orders/list',
                    { params: filter}
                ).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                }).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        },
        edit({dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/beauty-manager/orders/edit/' + editedItem.id,
                    prepareData(editedItem)
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        add({dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/beauty-manager/orders/add',
                    prepareData(editedItem)
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        complete({dispatch}, orderId) {
            return new Promise((resolve) => {
                axios.put('/api/beauty-manager/orders/complete/' + orderId).then(() => {
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        cancel({dispatch}, payload) {
            return new Promise((resolve) => {
                axios.delete('/api/beauty-manager/orders/cancel/' + payload.id, {
                    params: { text: payload.text }
                }).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        completedFetchClient({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.get(
                '/api/manager/service-orders/complete/list',
                { params: filter}
            ).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        completedFetchConsolidated({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.get(
                '/api/manager/service-orders/complete/consolidated',
                { params: filter}
            ).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        }
    }
}

function prepareData (data) {
    return {
        status: data.status,
        beauty_service_id: data.beauty_service_id,
        client_id: data.client_id,
        beauty_salon_id: data.beauty_salon_id,
        prices: data.prices,
        time_preparing: data.time_preparing
    }
}

